import React, { useEffect, useRef, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import {
  contentfulImageSrcSet,
  contentfulImageUrl,
} from '../lib/contentful-image'
import { flushSync } from 'react-dom'
import { createTagLayoutMotion } from './tag-layout-motion'
import SectionExpand from './section-expand'
import TagCard from './tagcard.js'
import SectionCaption from '../layouts/sectioncaption'
import '../pages/base.css'
import './tags.css'

const featuredTags = [
  '北京大学',
  '同济大学',
  '阿里通义实验室',
  '同济大学学生会',
  '吉林·通化',
]

const desktopCollapsedTags = [
  '信息工程学院',
  '软件学院',
  '阿里达摩院',
  '腾讯AI Lab',
  '百度Apollo',
  '大疆',
  'Apple Teacher',
  '蔚来',
]

const Tags = ({ data }) => {
  const { awardsHero } = useStaticQuery(graphql`
    query AwardsEntryHeroQuery {
      awardsHero: allContentfulHero(
        sort: { fields: [createdAt], order: ASC }
        filter: { page: { eq: "awards" } }
        limit: 1
      ) {
        edges {
          node {
            bg {
              fluid(maxWidth: 1000) {
                src
              }
            }
          }
        }
      }
    }
  `)
  const heroImage = awardsHero.edges[0].node.bg.fluid.src
  const [expanded, setExpanded] = useState(false)
  const groupRef = useRef(null)
  const motionRef = useRef(null)
  useEffect(() => {
    const motion = createTagLayoutMotion(groupRef.current)
    motionRef.current = motion
    window.addEventListener('resize', motion.cancel)
    return () => {
      window.removeEventListener('resize', motion.cancel)
      motion.cancel()
    }
  }, [])
  const toggleExpanded = () => {
    if (motionRef.current && window.matchMedia('(min-width: 641px)').matches) {
      motionRef.current.toggle(() => flushSync(() => setExpanded(!expanded)))
    } else {
      setExpanded(!expanded)
    }
  }
  return (
    <div className="Tags">
      <SectionCaption
        title="人生轨迹"
        emoji="⏳"
        subtitle="人生是个不断贴标签的过程"
      />
      <div
        className={`TagGroup${expanded ? ' TagGroupExpanded' : ''}`}
        id="life-trace-cards"
        ref={groupRef}
      >
        {data.map((edge, index) => (
          <div
            key={index}
            className={`TagEntry${
              !featuredTags.includes(edge.node.name) ? ' TagEntryExtra' : ''
            }${
              desktopCollapsedTags.includes(edge.node.name)
                ? ' TagEntryDesktopExtra'
                : ''
            }`}
          >
            <TagCard
              name={edge.node.name}
              description={edge.node.description}
              logo={edge.node.logo.fluid.src}
            />
          </div>
        ))}
        <div
          className="TagEntry TagEntryExtra TagEntryDesktopExtra TagEntryAwards"
          aria-hidden={!expanded}
        >
          <a
            className="TagCard TagCardAwards"
            href="/awards/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="但行耕耘：打开荣誉墙（在新标签页打开）"
            tabIndex={expanded ? 0 : -1}
          >
            <img
              className="TagCardAwardsBackground"
              src={contentfulImageUrl(heroImage, 960)}
              srcSet={contentfulImageSrcSet(heroImage, [480, 660, 960, 1320])}
              sizes="(max-width: 825px) 80vw, 660px"
              loading="lazy"
              decoding="async"
              alt=""
            />
            <div className="TagCardAwardsCopy">
              <h3>但行耕耘🏆</h3>
              <span className="TagCardAwardsSubtitle">
                让他着迷的是结果之外的一切
              </span>
              <span className="TagCardAwardsAction">
                打开荣誉墙 <i aria-hidden="true">→</i>
              </span>
            </div>
          </a>
        </div>
      </div>
      <SectionExpand
        className="TagsToggle"
        expanded={expanded}
        onToggle={toggleExpanded}
        controls="life-trace-cards"
        label="人生轨迹"
      />
    </div>
  )
}

export default React.memo(Tags)
